import { useAtomValue } from "jotai"
import React from "react"
import { ModalForm } from "@ant-design/pro-form"
import axiosApiInstance from "../../../../api/axiosClient"
import { useNavigate, useParams } from "react-router-dom"
import { queryClientAtom } from "jotai-tanstack-query"

const REDIRECT_URL = `/music/artists/`

export type DeleteArtistFormProps = {
  artistKey?: string
  onClose?: () => void
}

const decodeArtistKey = (raw?: string) => {
  if (!raw) return ""
  try {
    return decodeURIComponent(raw)
  } catch {
    return raw
  }
}

const DeleteArtistForm = ({ artistKey, onClose }: DeleteArtistFormProps) => {
  const { key_name: paramKey } = useParams()
  const key_name = decodeArtistKey(artistKey ?? paramKey)
  const navigate = useNavigate()
  const queryClient = useAtomValue(queryClientAtom)

  const close = () => {
    if (onClose) {
      onClose()
      return
    }
    navigate(REDIRECT_URL)
  }

  return (
    <ModalForm
      open
      width={400}
      title={`Delete Artist: ${key_name}`}
      submitter={{ submitButtonProps: { danger: true } }}
      autoFocusFirstInput
      onOpenChange={(nextOpen) => {
        if (!nextOpen) close()
      }}
      modalProps={{
        destroyOnClose: true,
        okText: "Delete",
        cancelText: "No",
        onCancel: close,
      }}
      onFinish={async () => {
        try {
          await axiosApiInstance.delete(
            `/api/products/artists/${encodeURIComponent(key_name)}`
          )
          queryClient.invalidateQueries({ queryKey: ["artists"] })
          close()
          return true
        } catch (reason) {
          console.log(reason)
          return false
        }
      }}
    >
      Are you sure?
    </ModalForm>
  )
}

export default DeleteArtistForm
